import type { SVGProps } from 'react';

const SvgPlatformAlt = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" viewBox="0 0 32 32" {...props}>
    <path
      fill={props.color}
      d="M29.8 11.2c-2.7-2.7-7-2.7-9.6 0l-8.9 8.9c-2.3 2.3-5.9 2.3-8.2 0s-2.3-5.9 0-8.2c2.2-2.2 5.9-2.3 8.2-.1-1.6 1.7-2.2 4.2-1.4 6.4l.9-.3q-.3-.9-.3-1.8c0-2.9 2.3-5.2 5.2-5.2.5 0 1 .1 1.5.2l.3-1q-.9-.3-1.8-.3c-1.3 0-2.7.4-3.7 1.2-2.7-2.7-7-2.7-9.6 0s-2.7 7 0 9.6c2.7 2.7 7 2.7 9.6 0l8.9-8.9c2.3-2.3 5.9-2.3 8.2 0s2.3 5.9 0 8.2-5.9 2.3-8.2 0q1.2-1.65 1.2-3.6 0-.9-.3-1.8l-1 .3q.3.75.3 1.5c0 2.9-2.3 5.2-5.2 5.2-.5 0-1-.1-1.6-.2l-.3 1q.9.3 1.8.3c1.6 0 3.2-.6 4.4-1.8 2.7 2.6 7 2.6 9.6-.1s2.6-6.8 0-9.5"
    />
  </svg>
);

export default SvgPlatformAlt;
